import React, {useState} from 'react';
import {directDeepLink, SOURCE_WEBVIEW} from '../../util';
import InternalBar from '../TopLayout/InternalBar/InternalBar';
import './tasksInt.css';
import { cosmosTrackService } from '../../../../cosmosTracking/cosmosTrackService';
import { PointsIcon } from '../Home/Icons';
import {
	bundling_learn_how,
	revenue_learn_how,
	trial_live_class_learn_how,
	notification_learn_how,
	coupon_code_learn_how,
	app_download_learn_how,
} from '../../../../cosmosTracking/cosmosEvents';

function TaskCardInt(props) {
	const { data} = props;
	const events = {
		14: bundling_learn_how,
		3: revenue_learn_how,
		9: trial_live_class_learn_how,
		5: notification_learn_how,
		2: coupon_code_learn_how,
		4: app_download_learn_how
	}

	// sorted task data
	const taskDataArr = data || [];
	const sortedTaskDataArr = [
		...taskDataArr.filter(item => !item?.isComplete)
	];

	function isMobile() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent);
	}

	const handleCardFun = (item)=>{
		cosmosTrackService(events[item?.statType]);
		if (isMobile()){
			directDeepLink(item?.button?.deeplink, SOURCE_WEBVIEW);
		}else {
			window.top.postMessage({ url: item?.button?.deeplink?.weblink }, '*');
		}
	}

	return (
		<>
			{sortedTaskDataArr?.map((item, index) => {
				return(
					<div className="task-card" key={index}>
						<h4>{item?.task}</h4>
						<p>{item?.taskInfo}</p>
						<div className="card-progressbar">
							<InternalBar width={item?.percentage}/>
							<div className="card-completed-text">
								{item?.statType === 3 ? (
									item?.completedText
								) : (
									<>
										{item?.total || 0} {item?.completedText}
									</>
								)}
							</div>
						</div>
						<hr/>
						<div className="card-footer">
							<button className="btn-gradient" onClick={()=>handleCardFun(item)}>
								{item?.button?.text}
							</button>
							<div className="card-point">
								<PointsIcon className="card-point-icon" />
								<span>{item?.points} pts</span>
							</div>
						</div>
					</div>
				)
			})}
		</>
	);
}

export default TaskCardInt;
